import React from "react";
import { CBadge } from "@coreui/react";

const Tab = ({ text, callBack, active, count = "" }) => {
  return (
    <div onClick={callBack} className={`hsc-tab${active ? "-selected" : ""}`}>
      {text}
      <CBadge
        style={{ color: "white", backgroundColor: "#2bc2f7" }}
        shape="rounded-circle"
      >
        {count}
      </CBadge>
    </div>
  );
};

const HorizontalSwitcherComponent = ({ currentTab, setCurrentTab }) => {
  return (
    <div className="container-fluid">
      <div className="d-flex">
        <Tab
          text={"Patient Snapshot"}
          callBack={() => {
            setCurrentTab(1);
          }}
          active={currentTab === 1}
        />
        <Tab
          text={"Assessments"}
          callBack={() => {
            setCurrentTab(2);
          }}
          active={currentTab === 2}
        />
        <Tab
          text={"Check Ins"}
          callBack={() => {
            setCurrentTab(3);
          }}
          active={currentTab === 3}
        />
        <Tab
          text={"Journal"}
          callBack={() => {
            setCurrentTab(4);
          }}
          active={currentTab === 4}
        />
        <Tab
          text={"Patient Notes"}
          callBack={() => {
            setCurrentTab(5);
          }}
          active={currentTab === 5}
        />
         <Tab
          text={"Billing Notes"}
          callBack={() => {
            setCurrentTab(8);
          }}
          active={currentTab === 8}
        />
        <Tab
          text={"Pinned Content"}
          callBack={() => {
            setCurrentTab(6);
          }}
          active={currentTab === 6}
        />
        {process.env.REACT_APP_DASHBOARD_TYPE === "youth" && (
          <Tab
            text={"DBT Diary Card Sessions"}
            callBack={() => {
              setCurrentTab(7);
            }}
            active={currentTab === 7}
          />
        )}
      </div>
    </div>
  );
};

export default HorizontalSwitcherComponent;
